/**
 * @generated SignedSource<<6b7df12eeacb086511e8c46aa249a328>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorSocialLinksAuthor$data = {
  readonly socialLinks: ReadonlyArray<{
    readonly class: string | null | undefined;
    readonly title: string | null | undefined;
    readonly url: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "authorSocialLinksAuthor";
};
export type authorSocialLinksAuthor$key = {
  readonly " $data"?: authorSocialLinksAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorSocialLinksAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorSocialLinksAuthor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SocialLink",
      "kind": "LinkedField",
      "name": "socialLinks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "class",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "a3036271a0239fec0f67d71a3e46fe53";

export default node;
